// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V9X9","label":"styles_label__2H52o"};